import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import type { FontType } from '../../FontType/FontType';
import { useRadioGroupContext } from '../RadioGroupContext';
import type { RadioVariant } from '../RadioVariant';
import styles from './Radio.module.css';

export interface RadioProps {
    value: string;
    label: string | React.ReactChild;
    variant?: RadioVariant;
    fontType?: FontType;
    className?: string;
}

export const Radio: React.FC<React.PropsWithChildren<RadioProps>> = ({
    value,
    label,
    className,
    variant = 'default',
    fontType = 'inherit',
}) => {
    const { name, currentValue, onChange, disabled } = useRadioGroupContext();
    const htmlId = uniqueId('FormComponents__radio__');
    const checked = value === currentValue;

    return (
        <div
            className={classNames(
                styles.Radio,
                variant && styles[`Variant--${variant}`],
                fontType && styles[`Variant--${fontType}Font`],
                className
            )}
        >
            <input
                type="radio"
                id={htmlId}
                className={styles.Input}
                checked={checked}
                value={currentValue}
                onChange={() => onChange(value)}
                name={name}
                disabled={disabled}
            />
            {label && (
                <label htmlFor={htmlId} className={styles.LabelOuter}>
                    <span className={styles.Label}>{label}</span>
                </label>
            )}
        </div>
    );
};
